<div class='nav-padding-placeholder'></div>
<nav 
	id="pcgMainNavigation" 
	class='navbar navbar-expand-lg top-nav-bg'
>
	<div 
		id='primaryNav' 
		class='align-items-center w-100'
	>
		<button 
			#mainHamburger 
			[class.d-none]="
				!navRoutes 
				|| navRoutes.length === 0
			" 
			(click)='toggleNav()' 
			id='mainHamburger' 
			class='float-right btn btn-sm mt-2'
		>
			<svg 
				viewBox='0 0 30 30' 
				xmlns='http://www.w3.org/2000/svg'
			>
				<path 
					stroke-width='2' 
					stroke-linecap='round' 
					stroke-miterlimit='10' 
					d='M4 7h22M4 15h22M4 23h22'
				></path>
			</svg>
		</button>

		<div class='navbar-header'>
			<a 
				[class.test]="mode !== 'Production'" 
				class='navbar-brand' 
				[routerLink]='["/"]'
			>
				<img 
					src="assets/images/logos/tms-logo.png" 
					style="max-width: 25px;"
				/>
				TTMS Fuel Dispenser
			</a>
		</div>

		<pcg-top-click-nav [navRoutes]='navRoutes'></pcg-top-click-nav>

		<div 
			id='rightNavContainer' 
			class='ml-auto align-items-center'
		>
			<ul 
				*ngIf="user" 
				#userNav 
				id="userNav" 				
				class="nav navbar-nav top-nav-bg"
			>
				<li 
					class="dropdown" 
					[class.bottom-arrow]="currSelectedNavMenu?.parentNav?.isInUserNav"
				>
					<a 
						href="#" 
						(click)="
							checkAccess(); 
							userNavOpen = !userNavOpen; 
							false
						" class="d-block dropdown-toggle"
					>{{ user.firstName }} {{ user.lastName }}</a>
					<ul 
						class="dropdown-menu top-nav-bg" 
						[class.nav-open]="userNavOpen"
					>
						<li 
							[routerLinkActive]='["link-active"]' 
							[routerLinkActiveOptions]='{ exact: true }'
						>
							<a 
								(click)="clickUserLink()" 
								class="d-block" 
								[routerLink]='"/edit-user/" + user.id'
							>My Profile</a>
						</li>
						<li [routerLinkActive]='["link-active"]'>
							<a 
								(click)="clickUserLink()" 
								class="d-block" 
								routerLink='/help'
							>Help</a>
						</li>
						<li>
							<a 
								class="d-block" 
								href="#" 
								(click)='
									logout(); 
									clickUserLink();
								'
							>Logout</a>
						</li>
					</ul>
				</li>
			</ul>
			
		</div>
	</div>
	<div 
		*ngIf="
			currSelectedNavMenu 
			&& currSelectedNavMenu.id !== 'root'
		" 
		id='secondaryNav'
	>
		<div class='container'>
			<span class='current-section'>{{ currSelectedNavMenu.name }}</span>
			<pcg-top-secondary-nav 
				[forceSelect]='currForceSelect' 
				[rootNavId]='"root" + navDividerCharacter + currSelectedNavMenu.id.split(navDividerCharacter)[1]' 
				[routeNavId]="currSelectedNavMenu.id" 
				[navRoutes]='currSelectedNavMenu.children'
			></pcg-top-secondary-nav>
		</div>
	</div>
</nav>
